module.exports = __webpack_public_path__ + "img/slika14.9f180ade.jpg";